import React from 'react';
import { useHistory } from 'react-router-dom';
import FAQData from '../../constants/FAQData';
import { isNativeApp } from '../../util/platformDetection';

const FAQMobile = () => {
  const history = useHistory();

  return (
    <div style={{
      width: '100vw',
      height: 'calc(100dvh - 55px)', // Account for bottom navigation
      backgroundColor: '#000',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      paddingTop: 'env(safe-area-inset-top)', // iPhone notch safe area
      paddingBottom: 'env(safe-area-inset-bottom)' // iPhone gesture area
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: '#1a1a1a',
        borderBottom: '1px solid #333',
        padding: '15px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <h2 style={{
          color: 'gold',
          margin: 0,
          fontSize: '24px',
          fontWeight: 'bold'
        }}>
          FAQ & Help
        </h2>
        <button
          onClick={() => history.goBack()}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: '#888',
            fontSize: '28px',
            cursor: 'pointer',
            padding: '5px'
          }}
        >
          ✕
        </button>
      </div>

      {/* FAQ Content */}
      <div style={{
        flex: 1,
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        padding: '15px 15px 80px 15px', // Extra bottom padding for better scrolling
        backgroundColor: '#000'
      }}>
        {FAQData.map((faq, index) => (
          <div
            key={index}
            style={{
              marginBottom: '15px',
              backgroundColor: '#1a1a1a',
              borderRadius: '8px',
              border: '1px solid #333',
              overflow: 'hidden'
            }}
          >
            <div
              style={{
                padding: '15px',
                borderBottom: '1px solid #333',
                backgroundColor: '#2a2a2a'
              }}
            >
              <h4 style={{ 
                color: 'gold', 
                margin: 0, 
                fontSize: '16px',
                fontWeight: 'bold'
              }}>
                {faq.question}
              </h4>
            </div>
            <div style={{ padding: '15px' }}>
              <p style={{ 
                color: 'white', 
                margin: 0, 
                fontSize: '14px',
                lineHeight: '1.5'
              }}>
                {faq.answer}
              </p>
            </div>
          </div>
        ))}
        
        {/* Spacer to ensure last item is fully visible */}
        <div style={{ height: '20px' }} />

      </div>
    </div>
  );
};

export default FAQMobile;